import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdPopup.css";
import { MyContext } from "../Context/MyContext";
import { resolveImage } from "../../Utils/imageUtils";

export default function AdPopup() {
  const { ads } = useContext(MyContext);
  const [showAd, setShowAd] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!ads?.duration) return undefined;

    const lastClosed = localStorage.getItem("adClosedTime");

    if (lastClosed) {
      const now = new Date().getTime();
      const diff = now - parseInt(lastClosed, 10);

      if (diff < 24 * 60 * 60 * 1000) return undefined;
    }

    const timer = setTimeout(() => {
      setShowAd(true);
    }, ads.duration);

    return () => clearTimeout(timer);
  }, [ads]);

  // ✅ AUTO CLOSE AFTER 10s
  useEffect(() => {
    if (!showAd) return;

    const autoClose = setTimeout(() => {
      handleClose();
    }, 10000); // 10 sec

    return () => clearTimeout(autoClose);
  }, [showAd]);

  const handleClose = () => {
    localStorage.setItem("adClosedTime", new Date().getTime());
    setShowAd(false);
  };

  const handleClick = () => {
    if (!ads?.car_id) return;
    handleClose();
    navigate(`/car/${ads.car_id}`);
  };

  if (!ads || !showAd) return null;

  return (
    <div className="ad-overlay">
      <div className="ad-box">

        {/* CLOSE WITH TIMER */}
        <div className="close-wrapper" onClick={handleClose}>
          <svg className="progress-ring" width="40" height="40">
            <circle
              className="progress-bg"
              cx="20"
              cy="20"
              r="18"
              strokeWidth="3"
              fill="transparent"
            />
            <circle
              className="progress-bar"
              cx="20"
              cy="20"
              r="18"
              strokeWidth="3"
              fill="transparent"
            />
          </svg>
          <span className="close-text">✕</span>
        </div>

        <img src={resolveImage(ads?.image)} alt="ad" onClick={handleClick} />

      </div>
    </div>
  );
}